import axios from 'axios';

const getNextRegNo = (state) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/farmer/nextRegNo`, { params: { state } })
    .then(res => res)
    .catch(err => err);
};

export default getNextRegNo;
